export default __webpack_public_path__ + "static/media/big-laugh-bird.c85a54fb.png";